import { useEffect, useRef, useState } from 'react';
import { SignUpCard } from './SignUpCard';
import { UnauthedPageWithNavbar } from '../../layout/UnauthedPageWithNavbar';
import SocialEntrepreneur from './social-entrepreneur.svg';
import Volunteer from './volunteer.svg';
import { ROUTES } from '../../routes/consts';
import { Link, useLocation, useSearchParams } from 'wouter';

export const HomeSignUp = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [searchParams] = useSearchParams();
  const [_, setLocation] = useLocation();

  if (searchParams.get('invite_id')) {
    setLocation(`${ROUTES.SIGN_UP_REP}?${searchParams.toString()}`);
  }

  useEffect(() => {
    const hideSidebar = (e: MouseEvent) => {
      if (isSidebarOpen && !e.composedPath().includes(sidebarRef.current as HTMLDivElement)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('click', hideSidebar, true);
    return () => document.removeEventListener('click', hideSidebar, true);
  }, [isSidebarOpen]);

  return (
    <UnauthedPageWithNavbar>
      <div className='md:w-full flex flex-col items-center mt-[20px] md:mt-[100px] gap-10 l px-4'>
        <h3 className='text-center text-display-md font-medium text-gray-700'>
          Which best describes you?
        </h3>
        <div className='flex flex-col md:flex-row gap-[48px]'>
          <SignUpCard
            img={Volunteer}
            header='Volunteer'
            description='I want to apply my skills to support social enterprises'
            url={`${ROUTES.SIGN_UP_PRO}?${searchParams.toString()}`}
          />
          <SignUpCard
            img={SocialEntrepreneur}
            header='Social Entrepreneur'
            description='I represent a social enterprise who is looking for support'
            url={`${ROUTES.SIGN_UP_REP}?${searchParams.toString()}`}
          />
        </div>
        <div className='pb-8 md:pb-0'>
          Already have an account?{' '}
          <Link className='text-brand-500 underline' to='~/platform/auth/login'>
            Log in
          </Link>
        </div>
      </div>
    </UnauthedPageWithNavbar>
  );
};
